var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5871 24.0586C50.8407 17.7708 53.4065 15.293 59.7815 12.309C53.5388 9.03194 51.0788 6.44757 48.1162 0.0266113C44.8626 6.31436 42.2967 8.79215 35.9218 11.7762C42.1645 15.0533 44.6245 17.6376 47.5871 24.0586Z",
    fill: "#446073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6136 45.0267C65.548 45.2665 80.3876 30.8793 80.7844 12.7887V12.2825H80.2818C63.9609 11.9095 50.1265 23.6857 47.3226 39.3784C45.2064 23.5791 31.9276 11.1901 15.6067 10.8171H15.1041V11.3234C14.7073 29.4139 28.8856 44.4672 46.82 45.0267C28.912 44.7869 14.046 59.1742 13.6492 77.2647V77.771H14.1518C30.4727 78.144 44.3071 66.3678 47.111 50.675C49.2271 66.4743 62.506 78.8633 78.8269 79.2363H79.3295V78.7301C79.7263 60.6395 65.548 45.5862 47.6136 45.0267ZM79.7792 13.2683C79.1179 30.4797 64.9396 44.1209 47.8516 44.0143C48.5129 26.8029 62.6912 13.1617 79.7792 13.2683ZM16.1093 11.8296C33.1972 12.4956 46.7407 26.7763 46.6349 43.9877C29.5469 43.3216 16.0035 29.0409 16.1093 11.8296ZM14.6544 76.7585C15.3157 59.5472 29.4675 45.906 46.582 46.0125C45.9207 63.2239 31.7688 76.8651 14.6544 76.7585ZM47.7987 46.0392C64.8867 46.7052 78.4301 60.9859 78.3243 78.1973C61.2364 77.5312 47.6929 63.2505 47.7987 46.0392Z",
    fill: "#B27D52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6349 65.968C43.3813 72.2558 40.8154 74.7336 34.4405 77.7176C40.6832 80.9947 43.1432 83.579 46.1058 90C49.3594 83.7122 51.9253 81.2344 58.3002 78.2504C52.0575 74.9733 49.5975 72.389 46.6349 65.968Z",
    fill: "#446073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3347 33.73C77.0811 40.0177 74.5152 42.4955 68.1403 45.4795C74.383 48.7566 76.843 51.341 79.8056 57.762C83.0592 51.4742 85.6251 48.9964 92 46.0124C85.7573 42.7353 83.2973 40.1509 80.3347 33.73Z",
    fill: "#446073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8861 44.4672C17.6435 41.1901 15.1834 38.6058 12.2208 32.1848C8.96723 38.4726 6.40139 40.9504 0.0264587 43.9344C6.26913 47.2115 8.72916 49.7958 11.6918 56.2168C14.9454 49.929 17.5112 47.4512 23.8861 44.4672Z",
    fill: "#446073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDecoration);
export default __webpack_public_path__ + "static/media/icon-decoration.e12c016870ef1686520922fed3db375f.svg";
export { ForwardRef as ReactComponent };